module.exports = __webpack_public_path__ + "files/SPIADI2022 - Rapport national Échoguidage.3b18a47148f8ec042cd26f1c01dfab30.pdf";